import { useState } from 'react';
import { X } from 'lucide-react';
import { LETTRES, LETTRE_HEX } from '../../utils/qcmTheme';

/**
 * Tiroir de secours de la vue scan : saisie manuelle d'une réponse pour un
 * élève dont la carte est abîmée ou absente. Le numéro de question est
 * rappelé dans le titre pour vérifier la coordination avec la projection
 * (les deux écrans partagent le même flux SSE).
 */
const SecoursDrawer = ({ open, onClose, numeroQuestion, restants, onScan, disabled }) => {
  const [code, setCode] = useState('');

  if (!open) return null;

  const envoyer = (lettre) => {
    if (code === '' || disabled) return;
    onScan({ code_aruco: Number(code), reponse: lettre });
    setCode('');
  };

  return (
    <div className="absolute inset-x-0 bottom-0 z-[20] flex flex-col rounded-t-3xl overflow-hidden" style={{ background: '#151a21', maxHeight: '75%' }}>
      {/* En-tête */}
      <div className="flex items-center justify-between px-5 pt-4 pb-3 flex-shrink-0">
        <h3 className="text-white font-bold text-[15px]">
          Saisie de secours
          <span className="ml-2 text-[12px] font-semibold" style={{ color: 'rgba(255,255,255,.5)' }}>
            Question {numeroQuestion}
          </span>
        </h3>
        <button
          type="button"
          onClick={onClose}
          aria-label="Fermer la saisie de secours"
          className="w-9 h-9 rounded-full flex items-center justify-center text-white"
          style={{ background: 'rgba(255,255,255,.1)' }}
        >
          <X size={16} />
        </button>
      </div>

      <div className="overflow-y-auto px-5 pb-6 space-y-4">
        {/* Élève + réponse */}
        <div>
          <label htmlFor="secours-eleve" className="block text-xs font-semibold mb-1.5" style={{ color: 'rgba(255,255,255,.6)' }}>
            Élève sans carte ou carte illisible
          </label>
          <select
            id="secours-eleve"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full px-3 py-2.5 rounded-xl text-sm font-semibold text-white"
            style={{ background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.2)' }}
          >
            <option value="" style={{ color: '#12161c' }}>Choisir un élève…</option>
            {restants.map((e) => (
              <option key={e.codeAruco} value={e.codeAruco} style={{ color: '#12161c' }}>
                {e.nom} (carte {e.codeAruco})
              </option>
            ))}
          </select>
          <div className="flex gap-2.5 mt-3">
            {LETTRES.map((l) => (
              <button
                key={l}
                type="button"
                onClick={() => envoyer(l)}
                disabled={code === '' || disabled}
                aria-label={`Réponse ${l}`}
                className="flex-1 h-12 rounded-xl text-white font-black text-lg transition disabled:opacity-30"
                style={{ background: LETTRE_HEX[l], fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
              >
                {l}
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default SecoursDrawer;
